import { useContext } from "react";
import { SeverityTypeContext } from "contexts/SeverityTypeContext";
import { getSeverityColour } from "core/utils/severityTypes";

/**
 * gets the properties of a severity
 * @param severityId the id of the severity
 * @returns {{colour: undefined, loading: boolean, error: boolean, severityName: undefined}}
 *
 * loading - whether the severities are currently loading
 *
 * error - whether an error occurred while fetching the severities
 *
 * severityName - the name of the severity relating to the id passed in
 *
 * colour - the css colour of the severity relating to the id passed in
 */
export const useSeverity = severityId => {
  const { loading, error, severityTypes } = useContext(SeverityTypeContext);
  let severityName = undefined;
  let colour = undefined;

  if (!loading && !error) {
    const severityType = severityTypes.find(
      severityType => severityType.id === severityId
    );

    if (severityType) {
      severityName = severityType.name;
      colour = getSeverityColour(severityType.colour);
    }
  }

  return {
    loading,
    error,
    severityName,
    colour
  };
};
